// extracted by mini-css-extract-plugin
module.exports = {"create-new-filter-button":"_2Q0iT-","createNewFilterButton":"_2Q0iT-"};